import { render, staticRenderFns } from "./TrueAndFalseSelector.vue?vue&type=template&id=9723218e&scoped=true&"
import script from "./TrueAndFalseSelector.vue?vue&type=script&lang=js&"
export * from "./TrueAndFalseSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9723218e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9723218e')) {
      api.createRecord('9723218e', component.options)
    } else {
      api.reload('9723218e', component.options)
    }
    module.hot.accept("./TrueAndFalseSelector.vue?vue&type=template&id=9723218e&scoped=true&", function () {
      api.rerender('9723218e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/project-detail/components/TrueAndFalseSelector.vue"
export default component.exports